import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { allPass as rAllPass, prop as rProp, piped as rPiped, constant as rConstant } from 'remeda';

import { CustomerPermissionActionEnum, CustomerPermissionSubjectEnum, type components } from '@/libs/openapi/schema';
import { hasPermissions } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
}

export const organizationUserInvitationPolicies = definePolicies((globalCtx: PolicyContext) => ({
  create: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_USER_INVITATION, [
      CustomerPermissionActionEnum.CREATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  manage: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_USER_INVITATION, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
}));
